import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { applyPageBranding, getBrand, getBrandConfig, getEnvironment, initializeSentry } from '@shared/services';

import packageInfo from '../package.json';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

initializeSentry('capture-send@' + packageInfo.version);

// Apply the host-based default brand before bootstrap (per-workflow branding, when
// present, still overrides this at runtime via ThemeService).
const brandConfig = getBrandConfig();
document.documentElement.setAttribute('data-brand', getBrand());
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', brandConfig.favicon);
applyPageBranding();

if (getEnvironment().production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) =>
  console.error(err),
);
